import publicRoutes from "./PublicPage";

const moduleRoutesMap = {
  ...publicRoutes,
};
export default moduleRoutesMap;
